import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceAdjustWorkloadNotificationState = createStateReducer(initialState, {
  [events.adjustWorkloadSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "adjustWorkload",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.adjustWorkloadFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "adjustWorkload",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceAdjustWorkloadNotificationState };
